// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.VGT-row[data-v-108c376e]:hover {\r\n  background-color: yellow;\n}\ntr:hover td[data-v-108c376e] {\r\n  background-color: yellow;\n}\r\n", ""]);
// Exports
module.exports = exports;
